import { api } from '../api';
export const programApi = api.injectEndpoints({
    endpoints: (build) => ({
        getProgram: build.query({
            query: (args) => ({
                url: `program-service/api/v1/widget/program`,
                headers: {
                    'X-Loyalty-Language': (args.locale).split('-')[0],
                    'Authorization': `Bearer ${args.jwt}`
                }
            }),
            forceRefetch: () => true
        })
    })
});
//# sourceMappingURL=program.api.js.map